'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* Aapo Komppa 15.2.2018:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This component does not work since departureService does not have a function called getReservableDeparturesBySearchCriteria
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * I assume that function is now called SearchReservableItems and the return data is different what this expects.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This component also seems to be divided to winresDeparturesList & winresDeparturesSearch. Use those if you want to search for departures / destinations.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresDeparturesController = function () {
    function WinresDeparturesController(departureService, internetClassificationService, localizationService, $scope, $timeout, $filter) {
        var _this = this;

        _classCallCheck(this, WinresDeparturesController);

        this.departureService = departureService;
        this.internetClassificationService = internetClassificationService;
        this.localizationService = localizationService;
        this.$scope = $scope;

        this.openState = {
            startDate: this.isStartDateOpen != 'false',
            endDate: this.isEndDateOpen == 'true',
            len: this.isLengthOpen == 'true',
            price: this.isPriceOpen == 'true',
            offer: this.isOfferOpen == 'true',
            primaryInternetClassifications: this.isPrimaryInternetClassificationsOpen == 'true',
            secondaryInternetClassifications: this.isSecondaryInternetClassificationsOpen == 'true'
        };

        this.allowChangeSecondaryInternetClassifications = this.allowChangeSecondaryInternetClassificationsInitial;
        this.allowChangePrimaryInternetClassifications = this.allowChangePrimaryInternetClassificationsInitial;

        //hide options if destinationCodes-parameter is set
        if (this.destinationCodes != null && this.destinationCodes != "") {
            this.allowChangeSecondaryInternetClassifications = 'false';
            this.allowChangePrimaryInternetClassifications = 'false';
        }

        this.startDate = new Date();
        if (this.defaultStartDate != null) {
            this.startDate = (0, _utils.parseISODate)(this.defaultStartDate);
        }
        this.returnDate = null;
        if (this.defaultEndDate != null) {
            this.returnDate = (0, _utils.parseISODate)(this.defaultEndDate);
        }

        if (this.defaultOffer === 'true') {
            this.showOnlyOffers = true;
        } else {
            this.showOnlyOffers = false;
        }

        this.departure_types = {};
        this.destinations = [];
        this.loadInternetClassifications();

        /*Length slider set up*/
        this.$scope.length_slider = {
            min: 1,
            max: 30,
            options: {
                floor: 1,
                ceil: 30,
                onEnd: function onEnd() {
                    _this.loadDepartures();
                },
                translate: function translate(num) {
                    return num + ' ' + $filter('i18next')('winres_departures.days_short');
                }
            }
        };
        if (this.sliderMaxLength) {
            this.$scope.length_slider.max = this.sliderMaxLength;
            this.$scope.length_slider.options.ceil = this.sliderMaxLength;
        }
        if (this.sliderMinLength) {
            this.$scope.length_slider.min = this.sliderMinLength;
            this.$scope.length_slider.options.floor = this.sliderMinLength;
        }
        if (this.allowChangeLength == 'false') {
            this.$scope.length_slider.options.disabled = true;
        }

        /*Price slider set up*/
        this.$scope.price_slider = {
            min: 0,
            max: 5000,
            options: {
                floor: 0,
                ceil: 5000,
                onEnd: function onEnd() {
                    _this.loadDepartures();
                },
                translate: function translate(num) {
                    return num + ' €';
                }
            }
        };
        if (this.sliderMaxPrice) {
            this.$scope.price_slider.max = this.sliderMaxPrice;
            this.$scope.price_slider.options.ceil = this.sliderMaxPrice;
        }
        if (this.sliderMinPrice) {
            this.$scope.price_slider.min = this.sliderMinPrice;
            this.$scope.price_slider.options.floor = this.sliderMinPrice;
        }
        if (this.allowChangePrice == 'false') {
            this.$scope.price_slider.options.disabled = true;
        }

        this.$scope.datepicker_options = {
            showWeeks: false,
            minDate: new Date(),
            startingDay: 1,
            maxMode: 'day',
            minMode: 'day'
        };
        $scope.$watchGroup(['$ctrl.returnDate', '$ctrl.startDate', '$ctrl.showOnlyOffers'], function () {
            if (_this.returnDate !== null && _this.startDate > _this.returnDate) {
                return;
            } else {
                _this.loadDepartures();
            }
        });

        var isInitial = true;
        $scope.$watch('$ctrl.departure_types', function () {
            if (isInitial) {
                return;
            }
            if (_this.returnDate !== null && _this.startDate > _this.returnDate) {
                return;
            } else {
                _this.loadDepartures();
            }
        }, true);

        $scope.$watch('$ctrl.destinations', function () {
            if (isInitial) {
                return;
            }
            if (_this.returnDate !== null && _this.startDate > _this.returnDate) {
                return;
            } else {
                _this.loadDepartures();
            }
        }, true);

        $timeout(function () {
            isInitial = false;
        });
    }

    _createClass(WinresDeparturesController, [{
        key: 'setClassificationChildrenEnabled',
        value: function setClassificationChildrenEnabled(classification, enabled) {
            var _this2 = this;

            if (classification.Children.length == 0) {
                classification.Value = enabled;
            } else {
                _.each(classification.Children, function (child) {
                    _this2.setClassificationChildrenEnabled(child, enabled);
                });
            }
        }

        // Sets Parent of each internet classification recursively. The parent
        // is needed when adding to search criteria, to make sure that the whole
        // trail of criteria is added.

    }, {
        key: 'addParentsToInternetClassifications',
        value: function addParentsToInternetClassifications(internetClassifications, currentParent) {
            var _this3 = this;

            if (currentParent) {
                // Do not create circular references, as not to cause an infinite loop
                // in angular.equals when watching.
                currentParent = _.clone(currentParent);
                delete currentParent.Children;
            }
            _.each(internetClassifications, function (classification) {
                classification.Parent = currentParent;
                _this3.addParentsToInternetClassifications(classification.Children, classification);
            });
        }
    }, {
        key: 'addLevelsToInternetClassifications',
        value: function addLevelsToInternetClassifications(internetClassifications, currentLevel) {
            var _this4 = this;

            _.each(internetClassifications, function (classification) {
                classification.Level = currentLevel;
                _this4.addLevelsToInternetClassifications(classification.Children, currentLevel + 1);
                if (classification.Children.length == 0) {
                    classification.Value = true;
                }
            });
        }
    }, {
        key: 'loadInternetClassifications',
        value: function loadInternetClassifications() {
            var _this5 = this;

            this.internetClassificationService.getInternetClassifications().then(function (internetClassifications) {
                _this5.addLevelsToInternetClassifications(internetClassifications, 1);
                _this5.addParentsToInternetClassifications(internetClassifications, null);
                _this5.internetClassifications = _.map(internetClassifications, function (internetClassification) {
                    _this5.setName(internetClassification);
                    internetClassification.Level = 1;
                    return internetClassification;
                });
                _.each(_this5.internetClassifications, function (classification) {
                    classification.Code = _.trim(classification.Code);
                    if (_this5.defaultInternetClassifications1 == null || _this5.defaultInternetClassifications1.includes(classification.Code)) {
                        _this5.departure_types[classification.Code] = true;
                    } else {
                        _this5.departure_types[classification.Code] = false;
                    }
                    _.each(classification.Children, function (child) {
                        _this5.addToDestinations(child);
                    });
                });
            });
        }
    }, {
        key: 'addToDestinations',
        value: function addToDestinations(elem) {
            var _this6 = this;

            elem.Code = _.trim(elem.Code);
            if (this['defaultInternetClassifications' + elem.Level] != undefined) {
                if (this['defaultInternetClassifications' + elem.Level].includes(elem.Code) || this['defaultInternetClassifications' + elem.Level] == null) {
                    elem.Value = true;
                } else {
                    elem.Value = false;
                }
            }
            // Null in value means that do not display the checkbox.
            if (elem.Children.length > 0) {
                elem.Value = null;
            }
            this.destinations.push(elem);
            _.each(elem.Children, function (child) {
                _this6.addToDestinations(child);
            });
        }
    }, {
        key: 'setName',
        value: function setName(elem) {
            var _this7 = this;

            //        if (elem.Name){
            switch (this.localizationService.getLanguage()) {
                case 'fi':
                    elem.Name = elem.NameFi;
                    break;
                case 'de':
                    elem.Name = elem.NameDe;
                    break;
                case 'en':
                    elem.Name = elem.NameEn;
                    break;
                case 'ru':
                    elem.Name = elem.NameRu;
                    break;
                case 'sv':
                    elem.Name = elem.NameSv;
                    break;
            }
            //        }
            if (elem.Children) {
                _.each(elem.Children, function (child) {
                    _this7.setName(child);
                });
            }
        }
    }, {
        key: 'getSearchCriteria',
        value: function getSearchCriteria() {
            var _this8 = this;

            var isoDateFormat = 'YYYY-MM-DD';
            var offer = this.showOnlyOffers ? true : null;
            var classifications = [[], [], [], [], []];

            classifications[0] = _.values(_.pickBy(this.internetClassifications, function (o) {
                return o.Code in _this8.departure_types && _this8.departure_types[o.Code];
            }));

            _.each(this.destinations, function (destination) {
                if (destination.Value === true) {
                    classifications[destination.Level - 1].push(destination);
                }
            });

            // Add parents so that in-between classes
            _.each(classifications, function (classificationsOnLevel) {
                _.each(classificationsOnLevel, function (classification) {
                    var current = classification;
                    while (current = current.Parent) {
                        classifications[current.Level - 1].push(current);
                    }
                });
            });

            // Convert all to codes
            classifications = _.map(classifications, function (classificationsOnLevel) {
                return _.map(classificationsOnLevel, 'Code');
            });

            // Adding parents WILL add duplicates. Removing then is just in case
            // though as they are passed into an IN (...) expression.
            classifications = _.map(classifications, _.uniq);

            var limit = this.limit;
            if (!limit) {
                limit = 10;
            }
            var DC = this.destinationCodes ? this.destinationCodes : null;

            return {
                DepartureDateMinimum: this.startDate ? moment(this.startDate).format(isoDateFormat) : null,
                DepartureDateMaximum: null,
                ReturnDateMinimum: null,
                ReturnDateMaximum: this.returnDate ? moment(this.returnDate).format(isoDateFormat) : null,
                LengthInDaysMinimum: this.$scope.length_slider.min ? this.$scope.length_slider.min : null,
                LengthInDaysMaximum: this.$scope.length_slider.max ? this.$scope.length_slider.max : null,
                Classifications1: classifications[0],
                Classifications2: classifications[1],
                Classifications3: classifications[2],
                Classifications4: classifications[3],
                Classifications5: classifications[4],
                showFullDepartures: this.showFullDepartures,
                DestinationGroup: null,
                DestinationCodes: DC,
                Types: null,
                PriceMinimum: this.$scope.price_slider.min ? this.$scope.price_slider.min : null,
                PriceMaximum: this.$scope.price_slider.max ? this.$scope.price_slider.max : null,
                IsOffer: offer,
                Limit: limit,
                Offset: 0
            };
        }
    }, {
        key: 'loadDepartures',
        value: function loadDepartures() {
            var _this9 = this;

            var searchCriteria = this.getSearchCriteria();
            var language = this.localizationService.getLanguage();
            this.departureService.getReservableDeparturesBySearchCriteria(searchCriteria, /*withReserveLink=*/true, language).then(function (result) {
                _this9.departures = result;
                _.each(_this9.departures, function (departure) {
                    departure.DateRange = (0, _utils.formatDateRange)(departure.Departure.DepartureDate, departure.Departure.ArrivalDate2);
                });
            });
        }
    }]);

    return WinresDeparturesController;
}();

WinresDeparturesController.$inject = ['departureService', 'internetClassificationService', 'localizationService', '$scope', '$timeout', '$filter'];

_module3.default.component('winresDepartures', {
    template: require('./winresDepartures.html'),
    controller: WinresDeparturesController,
    bindings: {
        language: '@',

        mode: '@',
        showSearchCriteria: '@',

        destinationCodes: '@',

        limit: '@',

        defaultOffer: '@',
        allowChangeOffer: '@',
        isOfferOpen: '@',

        defaultStartDate: '@',
        allowChangeStartDate: '@',
        isStartDateOpen: '@',

        defaultEndDate: '@',
        allowChangeEndDate: '@',
        isEndDateOpen: '@',

        sliderMinLength: '@',
        slideMaxLength: '@',
        allowChangeLength: '@',
        isLengthOpen: '@',

        sliderMinPrice: '@',
        sliderMaxPrice: '@',
        allowChangePrice: '@',
        isPriceOpen: '@',

        // Separated by ,
        defaultInternetClassifications1: '@',
        defaultInternetClassifications2: '@',
        defaultInternetClassifications3: '@',
        defaultInternetClassifications4: '@',
        defaultInternetClassifications5: '@',

        //internetClassificationSplit: '@',
        primaryInternetClassificationsTitle: '@',
        isPrimaryInternetClassificationsOpen: '@',
        allowChangePrimaryInternetClassifications: '@allowChangePrimaryInternetClassificationsInitial',

        secondaryInternetClassificationsTitle: '@',
        isSecondaryInternetClassificationsOpen: '@',
        allowChangeSecondaryInternetClassifications: '@allowChangeSecondaryInternetClassificationsInitial',

        reserveInNewWindow: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDepartures/winresDepartures.js
// module id = 282
// module chunks = 2